import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, ChevronDown } from "lucide-react";

const MEDAL = ["#FFD700", "#C0C0C0", "#CD7F32"];

export function PartnerLeaderboard() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    api.get("/admin/partner-analytics").then(({ data }) => setRows((data.by_partner || []).slice(0, 10))).catch(() => {});
  }, []);
  return (
    <div className="border border-[#FFD700]/30 bg-[#0F0F0F] rounded-lg overflow-hidden" data-testid="partner-leaderboard">
      <button onClick={() => setOpen((s) => !s)} className="w-full flex items-center justify-between px-4 py-3 text-left">
        <span className="flex items-center gap-2 text-sm font-semibold text-[#FFD700]"><Trophy className="h-4 w-4" /> Klasman Top Patnè (pa vant)</span>
        <ChevronDown className={`h-4 w-4 text-[#FFD700] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4">
          {rows.length === 0 ? <div className="text-center text-[#888] text-sm py-4">Pa gen done vant pou kounye a.</div> : (
            <div className="space-y-1.5">
              {rows.map((p, i) => (
                <div key={p.id} data-testid={`leaderboard-row-${i}`} className="flex items-center justify-between gap-3 px-3 py-2.5 bg-[#0A0A0A] border border-[#222] rounded-sm">
                  <div className="flex items-center gap-3 min-w-0">
                    <span className="font-heading text-sm font-bold w-6 text-center" style={{ color: MEDAL[i] || "#666" }}>{i + 1}</span>
                    <div className="min-w-0">
                      <div className="font-heading font-semibold text-sm truncate">{p.name || p.username}</div>
                      <div className="font-mono-term text-[10px] text-[#888]">{p.platform || "—"}{p.followers ? ` · ${p.followers} followers` : ""} · {p.customers} kliyan</div>
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-heading text-sm font-bold text-[#00F593]">${p.revenue?.gross || 0}</div>
                    <div className="font-mono-term text-[9px] uppercase text-[#555]">vant</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
